(function () {
    "use strict";

    // @ngInject
    function DashboardControllerCtor($scope, AppStates, UsersManager, AppConfigService, AnalyticsService, $injector) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'DashboardController';

        this.AppConfigService = AppConfigService;
        this.dashboardState = this.AppConfigService.dashboardState();

        this.tabs = [
            {tabName: 'DASHBOARD._FILES_TAB_', sref: AppStates.root_core_navigation_files},
            {tabName: 'DASHBOARD._CONTACTS_TAB_', sref: AppStates.root_core_navigation_contacts}
        ];

        var currentUser = UsersManager.getCurrUser();
        if (currentUser.isVendor()){
            this.tabs.unshift({tabName: 'DASHBOARD._EVENTS_TAB_', sref: AppStates.root_core_navigation_dashboard_workspace_cards});
        }

        AnalyticsService.track(this, AnalyticsService.analytics_events.dashboard_loaded);


    }


    Controllers.DashboardController = Class(Controllers.BaseController, {

        constructor: DashboardControllerCtor,

        goToWorkspace: function goToWorkspace(workspaceId) {
            this.goToState(this.AppStates.root_core_navigation_event_workspace, {workspace_id: workspaceId});
        }
    });
}());
